var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip-box"},[_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
        content: _vm.content,
        disabled: _vm.showTooltip,
        triggers: ['hover', 'focus', 'touch'],
        popperClass: 'text-over-tooltip-class',
    }),expression:"{\n        content,\n        disabled: showTooltip,\n        triggers: ['hover', 'focus', 'touch'],\n        popperClass: 'text-over-tooltip-class',\n    }"}],staticClass:"van-ellipsis",on:{"mouseover":function($event){return _vm.onMouseOver()}}},[_c('span',{ref:_vm.refName},[_vm._v(_vm._s(_vm.content))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }